import { gql } from '@apollo/client'

export const ZONE_HIERARCHY_GLOBAL_SEARCH_RESULT_FRAGMENT = gql`
  fragment ZoneHierarchyGlobalSearchResult on ZoneHierarchyGlobalSearchResult {
    zonePath
    name
    zoneId
  }
`
